import { render, staticRenderFns } from "./IconClipboardOutline.vue?vue&type=template&id=5c388d9e"
import script from "./IconClipboardOutline.vue?vue&type=script&lang=js"
export * from "./IconClipboardOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports